import Button from "../../ui/form/Button"
import { DownloadReportButtonProps } from "../../../types"
import { RootState } from "../../../store"
import { connect } from "react-redux"
import { downloadReport } from "../../../actions/reportsActions"
import { ADMIN_PERMISSIONS, errorFilledToastOptions, successFilledToastOptions } from "../../../constants"
import { toast } from "react-toastify"
import React, { useState } from "react"
import Tooltip from "../../ui/Tooltip"
import { KButton } from "kahuna-base-react-components"
import { lang } from "../../../constants/languages"
import UserSummaryModal from "./modal/UserSummaryModal"
import { checkAdminPermission } from "../../../utility"

const DownloadReportButton = (props: DownloadReportButtonProps) => {
  const [disabled, setDisabled] = useState(false)
  const [tooltipContent, setTooltipContent] = useState(lang.reports.list_component.download_report_button_tooltip)
  const [linkList, setLinkList] = useState<string[]>()

  const onClick = async () => {
    setDisabled(true)
    setTooltipContent(lang.reports.list_component.download_report_button_updated_tooltip)

    let linkList: string[] = []
    if (!props.isAdmin) {
      linkList = await props.downloadReport(props.reportId)
    } else if (props.isAdmin && props.selectedUserId) {
      linkList = await props.downloadReport(props.reportId, props.selectedUserId)
    }

    if (linkList?.length > 0) {
      setLinkList(linkList)
    } else {
      setLinkList(undefined)
      toast.error(lang.reports.list_component.link_not_found, errorFilledToastOptions)
    }

    setDisabled(false)
    setTooltipContent(lang.reports.list_component.download_report_button_tooltip)
  }

  return (
    <Tooltip place="left" content={tooltipContent}>
      <div className="w-[110px] flex flex-row justify-end">
        <UserSummaryModal linkList={linkList} setLinkList={setLinkList} />
        <KButton
          onClick={onClick}
          disabled={
            disabled ||
            (props.isAdmin &&
              !checkAdminPermission(ADMIN_PERMISSIONS.ROYALTY_REPORTS_DOWNLOAD, props.user?.adminPermissions))
          }
          width="36px"
          height="36px"
          padding="8px"
          icon="/mail-new.svg"
          borderRadius={10}
          background="#F7F7F7"
          hoverBackground="#F3F3F3"
          activeBackground="#F7F7F7"
          shadowDisabled
        />
      </div>
    </Tooltip>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps, { downloadReport })(DownloadReportButton)
